import { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { BookOpen, Monitor, DollarSign, CheckCircle, Loader2, GraduationCap, Bot } from 'lucide-react'
import ReCAPTCHA from 'react-google-recaptcha'
import API from "../providers/api";

gsap.registerPlugin(ScrollTrigger)

const modulosOptions = [
  { id: 'academico', label: 'Módulo Académico', desc: 'Gestión académica integral', icon: BookOpen },
  { id: 'aula-virtual', label: 'Módulo Aula Virtual', desc: 'Aprendizaje en línea', icon: Monitor },
  { id: 'financiero', label: 'Módulo Financiero', desc: 'Gestión de recibos de pagos y cobros', icon: DollarSign },
  { id: 'alania', label: 'Módulo AlanIA', desc: 'Asistente de IA para la gestión investigativa', icon: Bot }
]

const LeadForm = () => {
  const recaptcha = useRef()
  const sectionRef = useRef(null)
  const headerRef = useRef(null)
  const formCardRef = useRef(null)

  const [formData, setFormData] = useState({
    colegio: '',
    estudiantes: '',
    modulos: [],
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '-', 
    recaptcha: '',
  })

  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        headerRef.current.children,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: headerRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      )

      gsap.fromTo(
        formCardRef.current,
        { opacity: 0, scale: 0.95, y: 40 },
        {
          opacity: 1,
          scale: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: formCardRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  const validate = () => {
    const newErrors = {}
    if (!formData.colegio.trim()) newErrors.colegio = 'Este campo es obligatorio'
    if (!formData.estudiantes.trim()) {
      newErrors.estudiantes = 'Este campo es obligatorio'
    } else if (isNaN(Number(formData.estudiantes)) || Number(formData.estudiantes) <= 0) {
      newErrors.estudiantes = 'Ingresa una cantidad válida'
    }
    if (formData.modulos.length === 0) newErrors.modulos = 'Selecciona al menos un módulo'
    if (!formData.nombre.trim()) newErrors.nombre = 'Este campo es obligatorio'
    if (!formData.email.trim()) {
      newErrors.email = 'Este campo es obligatorio'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Ingresa un correo válido'
    }
    const captchaValue = recaptcha?.current.getValue()
    console.log("Captcha Value =>", captchaValue)
    if (!captchaValue) {
        newErrors.captcha = 'Ingresa el código de seguridad'
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }))
  }

  const toggleModulo = (id) => {
    setFormData((prev) => {
      const modulos = prev.modulos.includes(id)
        ? prev.modulos.filter((m) => m !== id)
        : [...prev.modulos, id]
      return { ...prev, modulos }
    })
    if (errors.modulos) setErrors((prev) => ({ ...prev, modulos: '' }))
  }

  const limpiarCampos = () => {
    setFormData({
      colegio: '',
      estudiantes: '',
      modulos: [],
      /* nombre: '',
      email: '',
      telefono: '',*/
      mensaje: '-', 
      recaptcha: '',
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return
    setIsSubmitting(true)
    formData.recaptcha = recaptcha?.current.getValue()
    API.guardarCRMFormWeb(formData)
    .then(data => data.json())
    .then(dataJson => {
        if (dataJson.success == true) {
            setIsSubmitting(false)
            setSubmitted(true)
            limpiarCampos()
        }else{
            alert(`Error al enviar formulario`)
        }
    })
    .catch((e) => {
        console.log("Error =>", e)
        setIsSubmitting(false)
        setSubmitted(true)
    })
    
  }

  return (
    <section
      id="solicitar-demo"
      ref={sectionRef}
      className="section-padding"
      style={{
        background: 'linear-gradient(180deg, #0F293E 0%, #152d42 100%)',
      }}
    >
      {/* Subtle grid pattern */}
      <div
        className="inset-0 opacity-[0.02]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      />

      <div className="container-main relative z-10">
        <div ref={headerRef} className="text-center mb-12">
          <span
            className="badge-pill"
            style={{
              backgroundColor: '#10B981',
              color: 'white',
              fontSize: '12px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            ¿QUÉ ESPERAS?
          </span>
          <h2
            className="mt-4 text-3xl md:text-[42px] font-bold"
            style={{ color: 'white', lineHeight: 1.2 }}
          >
            Estás a un paso para comenzar tu Transformación Digital Hoy
          </h2>
          <p
            className="mt-4 text-lg mx-auto"
            style={{
              color: 'rgba(255,255,255,0.7)',
              lineHeight: 1.6,
              maxWidth: 600,
            }}
          >
            {/* Completa el siguiente formulario, para aceptar esta propuesta comercial. */}
            Completa el formulario y un asesor especializado te contactará en el
            menor tiempo posible con una propuesta personalizada para tu colegio.
          </p>
        </div>

        <div
          ref={formCardRef}
          className="mx-auto"
          style={{
            maxWidth: 900,
            backgroundColor: 'white',
            borderRadius: 24,
            boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
          }}
        >
          {submitted ? (
            <div
              className="text-center"
              style={{ padding: '48px 40px' }}
            >
              <CheckCircle size={48} color="#10B981" strokeWidth={2} />
              <h3
                className="mt-5 text-2xl font-bold"
                style={{ color: '#0F293E' }}
              >
                ¡Solicitud Enviada!
              </h3>
              <p
                className="mt-3 text-base"
                style={{ color: '#4B5563' }}
              >
                Gracias por tu interés. Muy pronto te contactaremos para iniciar el proceso de adaptación de nuestro sistema.
              </p>
              <button
                onClick={() => {
                  setSubmitted(false)
                  setFormData({
                    colegio: '',
                    estudiantes: '',
                    modulos: [],
                    nombre: '',
                    email: '',
                    telefono: '',
                    mensaje: '-',
                    recaptcha: '',
                  })
                  document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' })
                }}
                className="mt-6 btn-primary"
              >
                Volver al inicio
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="p-8 md:p-12">
              <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                {/* Nombre del colegio */}
                {<div className="md:col-span-2">
                  <label
                    className="block text-sm font-semibold mb-2"
                    style={{ color: '#0F293E' }}
                  >
                    Nombre de la Institución <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="colegio"
                    value={formData.colegio}
                    onChange={handleChange}
                    placeholder="Ej: Colegio San José"
                    className="w-full px-4 py-3.5 rounded-xl text-base transition-all duration-200 focus:outline-none"
                    style={{
                      border: `2px solid ${errors.colegio ? '#EF4444' : '#D1D5DB'}`,
                      boxShadow: errors.colegio ? '0 0 0 3px rgba(239,68,68,0.1)' : 'none',
                    }}
                    onFocus={(e) => {
                      if (!errors.colegio) e.currentTarget.style.borderColor = '#10B981'
                    }}
                    onBlur={(e) => {
                      if (!errors.colegio) e.currentTarget.style.borderColor = '#D1D5DB'
                    }}
                  />
                  {errors.colegio && (
                    <p className="mt-1.5 text-sm" style={{ color: '#EF4444' }}>
                      {errors.colegio}
                    </p>
                  )}
                </div>}

                {/* Cantidad de Estudiantes */}
                <div>
                  <label
                    className="block text-sm font-semibold mb-2"
                    style={{ color: '#0F293E' }}
                  >
                    Cantidad de Estudiantes <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input
                    type="number"
                    name="estudiantes"
                    value={formData.estudiantes}
                    onChange={handleChange}
                    placeholder="Ej: 500"
                    min="1"
                    className="w-full px-4 py-3.5 rounded-xl text-base transition-all duration-200 focus:outline-none"
                    style={{
                      border: `2px solid ${errors.estudiantes ? '#EF4444' : '#D1D5DB'}`,
                      boxShadow: errors.estudiantes ? '0 0 0 3px rgba(239,68,68,0.1)' : 'none',
                    }}
                    onFocus={(e) => {
                      if (!errors.estudiantes) e.currentTarget.style.borderColor = '#10B981'
                    }}
                    onBlur={(e) => {
                      if (!errors.estudiantes) e.currentTarget.style.borderColor = '#D1D5DB'
                    }}
                  />
                  {errors.estudiantes && (
                    <p className="mt-1.5 text-sm" style={{ color: '#EF4444' }}>
                      {errors.estudiantes}
                    </p>
                  )}
                </div>

                {/* Nombre del Contacto */}
                {<div>
                  <label
                    className="block text-sm font-semibold mb-2"
                    style={{ color: '#0F293E' }}
                  >
                    Tu Nombre <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    placeholder="Ej: María González"
                    className="w-full px-4 py-3.5 rounded-xl text-base transition-all duration-200 focus:outline-none"
                    style={{
                      border: `2px solid ${errors.nombre ? '#EF4444' : '#D1D5DB'}`,
                      boxShadow: errors.nombre ? '0 0 0 3px rgba(239,68,68,0.1)' : 'none',
                    }}
                    onFocus={(e) => {
                      if (!errors.nombre) e.currentTarget.style.borderColor = '#10B981'
                    }}
                    onBlur={(e) => {
                      if (!errors.nombre) e.currentTarget.style.borderColor = '#D1D5DB'
                    }}
                  />
                  {errors.nombre && (
                    <p className="mt-1.5 text-sm" style={{ color: '#EF4444' }}>
                      {errors.nombre}
                    </p>
                  )}
                </div>}

                {/* Correo Electrónico */}
                {<div>
                  <label
                    className="block text-sm font-semibold mb-2"
                    style={{ color: '#0F293E' }}
                  >
                    Correo Electrónico <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Ej: contacto@colegio.edu"
                    className="w-full px-4 py-3.5 rounded-xl text-base transition-all duration-200 focus:outline-none"
                    style={{
                      border: `2px solid ${errors.email ? '#EF4444' : '#D1D5DB'}`,
                      boxShadow: errors.email ? '0 0 0 3px rgba(239,68,68,0.1)' : 'none',
                    }}
                    onFocus={(e) => {
                      if (!errors.email) e.currentTarget.style.borderColor = '#10B981'
                    }}
                    onBlur={(e) => {
                      if (!errors.email) e.currentTarget.style.borderColor = '#D1D5DB'
                    }}
                  />
                  {errors.email && (
                    <p className="mt-1.5 text-sm" style={{ color: '#EF4444' }}>
                      {errors.email}
                    </p>
                  )}
                </div>}

                {/* Teléfono */}
                {<div>
                  <label
                    className="block text-sm font-semibold mb-2"
                    style={{ color: '#0F293E' }}
                  >
                    Teléfono de Contacto
                  </label>
                  <input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    placeholder="Ej: +57 300 123 4567"
                    className="w-full px-4 py-3.5 rounded-xl text-base transition-all duration-200 focus:outline-none"
                    style={{ border: '2px solid #D1D5DB' }}
                    onFocus={(e) => { e.currentTarget.style.borderColor = '#10B981' }}
                    onBlur={(e) => { e.currentTarget.style.borderColor = '#D1D5DB' }}
                  />
                </div>}

                {/* Módulos */}
                <div className="md:col-span-2">
                  <label
                    className="block text-sm font-semibold mb-3"
                    style={{ color: '#0F293E' }}
                  >
                    ¿Qué módulos te interesan? <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                    {modulosOptions.map((mod) => {
                      const isSelected = formData.modulos.includes(mod.id)
                      return (
                        <button
                          key={mod.id}
                          type="button"
                          onClick={() => toggleModulo(mod.id)}
                          className="relative cursor-pointer text-left transition-all duration-200"
                          style={{
                            border: `2px solid ${isSelected ? '#10B981' : '#D1D5DB'}`,
                            borderRadius: 12,
                            padding: 16,
                            backgroundColor: isSelected ? '#F0FDF4' : 'white',
                            boxShadow: isSelected ? '0 4px 12px rgba(16,185,129,0.15)' : 'none',
                          }}
                        >
                          <div className="flex items-center gap-3">
                            <div
                              className="flex items-center justify-center rounded-full"
                              style={{
                                width: 40,
                                height: 40,
                                backgroundColor: isSelected ? 'rgba(16,185,129,0.15)' : '#F3F4F6',
                              }}
                            >
                              <mod.icon
                                size={20}
                                color={isSelected ? '#10B981' : '#6B7280'}
                                strokeWidth={2}
                              />
                            </div>
                            <div>
                              <p
                                className="font-semibold text-[15px]"
                                style={{ color: isSelected ? '#10B981' : '#0F293E' }}
                              >
                                {mod.label}
                              </p>
                              <p className="text-[13px]" style={{ color: '#6B7280' }}>
                                {mod.desc}
                              </p>
                            </div>
                          </div>
                          {isSelected && (
                            <div
                              className="absolute top-3 right-3 flex items-center justify-center rounded-full"
                              style={{
                                width: 20,
                                height: 20,
                                backgroundColor: '#10B981',
                              }}
                            >
                              <CheckCircle size={14} color="white" strokeWidth={3} />
                            </div>
                          )}
                        </button>
                      )
                    })}
                  </div>
                  {errors.modulos && (
                    <p className="mt-2 text-sm" style={{ color: '#EF4444' }}>
                      {errors.modulos}
                    </p>
                  )}
                </div>

                {/* Mensaje adicional */}
                <div className="md:col-span-2">
                  <label
                    className="block text-sm font-semibold mb-2"
                    style={{ color: '#0F293E' }}
                  >
                    ¿Algo más que quieras contarnos?
                  </label>
                  <textarea
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    placeholder="Cuéntanos sobre las necesidades específicas de tu institución..."
                    rows={4}
                    className="w-full px-4 py-3.5 rounded-xl text-base transition-all duration-200 focus:outline-none resize-none"
                    style={{ border: '2px solid #D1D5DB' }}
                    onFocus={(e) => { e.currentTarget.style.borderColor = '#10B981' }}
                    onBlur={(e) => { e.currentTarget.style.borderColor = '#D1D5DB' }}
                  />
                </div>

                  {/* ReCAPTCHA */}
                <div className='md:col-span-2' style={{textAlign: 'center'}}>
                  <ReCAPTCHA ref={recaptcha} sitekey={import.meta.env.VITE_SITE_KEY} />
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="mt-8 w-full font-bold text-base cursor-pointer transition-all duration-200"
                style={{
                  backgroundColor: isSubmitting ? '#10B981' : '#10B981',
                  color: 'white',
                  padding: '16px',
                  borderRadius: 12,
                  opacity: isSubmitting ? 0.7 : 1,
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) e.currentTarget.style.backgroundColor = '#059669'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#10B981'
                }}
              >
                <div className="flex items-center justify-center gap-2">
                  {isSubmitting ? (
                    <>
                      <Loader2 size={20} className="spin-loader" />
                      <span>Enviando...</span>
                    </>
                  ) : (
                    <>
                      <GraduationCap size={20} />
                      <span>Enviar respuesta</span>
                    </>
                  )}
                </div>
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}

export default LeadForm
